// Refactored Perfume component with reusable components and cleaner structure
import React, { useEffect } from "react";
import "./Perfume.css";
import CatalogSection from "../../components/CatalogSection/CatalogSection";
import { useSEO } from "../../context/SEOContext";
import MenFoto from "./../../assets/perfume/parfumepagemen.webp";
import BannerMenBottom from "./../../assets/perfume/bannerbttom.webp";
import Logo1 from "./../../assets/home/test1.png";
import Logo2 from "./../../assets/home/test2.png";
import MainCharactersBannerWomen from "../../assets/mcwomen.webp";
import MainCharactersBannerMen from "./../../assets/mcmen.webp";
import WomenFoto from "./../../assets/perfume/parfumpagewomen.webp";
import BannerWomanBottom from "./../../assets/perfume/bannerbottomfemale.webp";

import Artboard1 from "./../../assets/perfume/artboard1.webp";
import Artboard2 from "./../../assets/perfume/artboard2.webp";
import Artboard3 from "./../../assets/perfume/artboard3.webp";

//import bannerImage from "./../../assets/perfume/parfumepagebanner.webp";
//import bannerImageMobil from "./../../assets/perfume/parfumepagebannermobile.webp";
import bannerImage from "./../../assets/perfume/banner1.webp";
import bannerImageMobil from "./../../assets/perfume/banner1mobile.webp";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import NotesSection from "./../../components/NotesSection/NotesSection";
const NoteBlock = ({ image, title, notes }) => (
  <div className="d-flex align-items-center mt-4">
    <img src={image} alt={title} className="me-3 artbmoardsize" />
    <div>
      <p className="mb-1 fw-semibold">{title}</p>
      <p className="mb-0 text-muted">{notes}</p>
    </div>
  </div>
);
const BannerOverlay = ({ img, text }) => (
  <div className="row mt-5 d-none d-sm-block">
    <div
      className="col-lg-12 px-0 position-relative"
      style={{ height: "440px" }}
    >
      <img
        src={img}
        alt="Mukemel Perfume for Men & Women"
        className="w-100 h-100"
      />
      {/* <div className="position-absolute top-50 start-50 translate-middle text-center text-white perfumebannertext">
        <div className="bgbannercolor p-4">
          <p>{text}</p>
        </div>
      </div> */}
    </div>
  </div>
);

const AccordionSection = ({ gender, inspiration, id }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-5">
      <div className="accordion" id={`accordion${id}`}>
        <div className="accordion-item">
          <h2 className="accordion-header" id={`headingGender${id}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapseGender${id}`}
              aria-expanded="false"
              aria-controls={`collapseGender${id}`}
            >
              {t("Gender")}
            </button>
          </h2>
          <div
            id={`collapseGender${id}`}
            className="accordion-collapse collapse"
            aria-labelledby={`headingGender${id}`}
            data-bs-parent={`#accordion${id}`}
          >
            <div className="accordion-body">{gender}</div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id={`headingInspiration${id}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapseInspiration${id}`}
              aria-expanded="false"
              aria-controls={`collapseInspiration${id}`}
            >
              {t("Inspiration")}
            </button>
          </h2>
          <div
            id={`collapseInspiration${id}`}
            className="accordion-collapse collapse"
            aria-labelledby={`headingInspiration${id}`}
            data-bs-parent={`#accordion${id}`}
          >
            <div className="accordion-body">{inspiration}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Perfume = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("perfume.meta.title"),
      description: t("perfume.meta.description"),
      keywords: t("perfume.meta.keywords"),
      favicon: "/faviconnew.png", // ✅ burada favicon tanımlandı
      ogImage:
        "https://mukemel.com/static/media/brothers.c791973cd1c46d462816.webp",
      ogUrl: "https://mukemel.com/perfume",
      ogType: "perfume", // ya da 'website'
    });
  }, [setSeo, t]);
  return (
    <>
      <div className="container-fluid">
        <div className="row d-none d-sm-block">
          <div className="col-lg-12 pe-0 px-0 d-none d-sm-block">
            <a href="/category/perfume">
              <img
                src={bannerImage}
                alt="Mukemel perfume banner with man and woman applying fragrance"
                title="Mukemel Perfume - Sensual Fragrance for Men & Women"
                className="w-100 banner-img"
              />
            </a>
          </div>
          <div className="col-lg-12 pe-0 px-0 d-block d-sm-none">
            <a href="/category/perfume">
              <img
                src={bannerImageMobil}
                alt="Mukemel mobile perfume banner showing couple using fragrance"
                title="Mukemel Perfume – Luxury Scents for All"
                className="w-100 banner-img2"
              />
            </a>
          </div>
        </div>
        <h1 className="text-center fw-normal my-5 my-sm-4 fs-5">
          <span dangerouslySetInnerHTML={{ __html: t("TitleText") }} />
        </h1>
      </div>
      <div className="container my-5">
        {/* Women Section */}
        <div className="row pb-5 mt-5">
          <div className="col-lg-6 text-center px-0">
            <div className="position-relative d-block">
              <a href="/product/218">
                <img
                  src={WomenFoto}
                  className="w-100 mb-4"
                  alt="Perfume for Women perfume with raspberry, orange and amber notes"
                  title="Perfume for Women"
                />
                <p className="text-decoration-underline text-white mb-5 position-absolute bottom-0 start-50 translate-middle-x border border-light p-2 pe-4 px-4 rounded-2 fw-bold">
                  {t("View More")}
                </p>
              </a>
            </div>
          </div>
          <div className="col-lg-6 px-4">
            <h2 className="fs-5 mt-4">{t("Perfume for Women")}</h2>
            <NotesSection
              variant="women"
              Artboard1={Artboard1}
              Artboard2={Artboard2}
              Artboard3={Artboard3}
              NoteBlock={NoteBlock}
            />
            <AccordionSection
              id="Women"
              gender={t("Women")}
              inspiration={t("WomenDesc")}
            />
          </div>
        </div>
        {/* Women Pyramid Section */}
        <div className="d-none d-sm-block">
          <div className="row">
            <img
              src={MainCharactersBannerWomen}
              className="w-100 pe-0 px-0 pt-4"
              alt="Mukemel Perfume for"
            />
          </div>
        </div>

        <BannerOverlay img={BannerWomanBottom} text={t("WomenDesc")} />
        {/* Men Section */}
        <div className="row mt-5 ">
          <div className="col-lg-6 text-center px-0">
            <div className="position-relative d-block">
              <a href="/product/219">
                <img
                  src={MenFoto}
                  className="w-100 mb-4"
                  alt="Perfume for Men perfume with grapefruit, vanilla and amber notes"
                  title="Perfume for Men"
                />
                <p className="text-decoration-underline text-white mb-5 position-absolute bottom-0 start-50 translate-middle-x border border-light p-2 pe-4 px-4 rounded-2 fw-bold">
                  {t("View More")}
                </p>
              </a>
            </div>
          </div>
          <div className="col-lg-6 px-4">
            <h2 className="fs-5 mt-4">{t("Perfume for Men")}</h2>
            <NotesSection
              variant="men"
              Artboard1={Artboard1}
              Artboard2={Artboard2}
              Artboard3={Artboard3}
              NoteBlock={NoteBlock}
            />
            <AccordionSection
              id="Men"
              gender={t("Men")}
              inspiration={t("MenDesc")}
            />
          </div>
        </div>
        {/* Men Pyramid Section */}

        <div className="d-none d-sm-block">
          <div className="row">
            <img
              src={MainCharactersBannerMen}
              className="w-100 pe-0 px-0 pt-4"
              alt="Mukemel Perfume for"
            />
          </div>
        </div>
        <BannerOverlay img={BannerMenBottom} text={t("MenDesc")} />
      </div>

      {/* YouTube Section */}
      <div className="container mb-5 pe-0 px-0">
        <Swiper
          spaceBetween={30}
          pagination={{ clickable: true, el: ".video-swiper-pagination" }}
          modules={[Pagination]}
          className="mySwiper"
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 1 }, // istersen 2 yap
            1024: { slidesPerView: 2 }, // desktop'ta yan yana 2 video
          }}
        >
          <SwiperSlide>
            <div className="text-center mt-3">
              <h2 className="fs-5 mb-3">{t("Fragrance for men")}</h2>
              <div className="ratio ratio-16x9">
                <iframe
                  src="https://www.youtube.com/embed/zQQFBriEXEg"
                  title={t("Mukemel Fragrance Ad for Men")}
                  allowFullScreen
                />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="text-center mt-3">
              <h2 className="fs-5 mb-3">{t("Fragrance for women")}</h2>
              <div className="ratio ratio-16x9">
                <iframe
                  src="https://www.youtube.com/embed/3vBHdvg7z4k"
                  title={t("Mukemel Fragrance for Women")}
                  allowFullScreen
                />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div className="video-swiper-pagination mb-5 text-center" />
      </div>
      <div className="container text-center d-block d-sm-none">
        <div className="row justify-content-center mb-5">
          <h4 className="py-3">{t("Memberof")}</h4>
          <div className="col-6">
            <img
              src={Logo1}
              className="w-100"
              alt="Logo of IFF, the fragrance company behind MÜKEMEL Perfume"
            />
          </div>
          <div className="col-6">
            <img
              src={Logo2}
              className="w-100"
              alt="Logo of IFF, the fragrance company behind MÜKEMEL Perfume"
            />
          </div>
        </div>
      </div>

      {/* ── Digital Catalogue Section ── */}
      <CatalogSection />
    </>
  );
};

export default Perfume;
